import { createI18n } from 'vue-i18n';

const STORAGE_KEY = 'user_language';
const DEFAULT_LANG = 'uk';

// Отримання мови з localStorage
export function getSavedLanguage() {
  return localStorage.getItem(STORAGE_KEY) || DEFAULT_LANG;
}

// Встановлення мови в i18n та localStorage
export function setLanguage(lang) {
  localStorage.setItem(STORAGE_KEY, lang);
  index.global.locale.value = lang;
  document.documentElement.setAttribute('lang', lang);
}

const index = createI18n({
  legacy: false, // Для Composition API
  locale: getSavedLanguage(),
  fallbackLocale: 'uk',
  messages: {
    // Якщо у вас є базові UI-переклади на фронті (кнопки, заголовки):
    uk: {
      select_language: "Мова",
      download_pdf: "Завантажити PDF"
    },
    en: {
      select_language: "Language",
      download_pdf: "Download PDF"
    }
  }
});

export default index;